/* tslint:disable */
/* eslint-disable */
/**
 * noco-server
 * noco-server
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { exists } from '../runtime';
export function RemoveCompanyListRequestFromJSON(json) {
    return RemoveCompanyListRequestFromJSONTyped(json, false);
}
export function RemoveCompanyListRequestFromJSONTyped(json, ignoreDiscriminator) {
    if (json === undefined || json === null) {
        return json;
    }
    return {
        companyIds: !exists(json, 'company_ids') ? undefined : json['company_ids']
    };
}
export function RemoveCompanyListRequestToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        company_ids: value.companyIds
    };
}
